import { render } from "./SenderAdd.vue?vue&type=template&id=12e7314c"
import script from "./SenderAdd.vue?vue&type=script&lang=js"
export * from "./SenderAdd.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__